import BasicContentIconCard from './BasicContentIconCard';

export { type BasicContentIconCardProps } from './BasicContentIconCard';
export default BasicContentIconCard;
